import { v4 as uuidv4 } from 'uuid'

class UUID {
  constructor(app) {
    this.app = app
  }

  getDeviceId() {
    if (typeof localStorage === 'undefined') return

    const deviceId = localStorage.getItem('lole_device_uuid')
    if (deviceId && deviceId !== '') {
      return deviceId
    } else {
      const newId = uuidv4()
      localStorage.setItem('lole_device_uuid', newId)
      return newId
    }
  }
}

export default ({ app }, inject) => {
  inject('uuid', new UUID(app))
}
